import { create } from 'zustand'
import type { CartItem } from '@/types/order'

interface CartState {
  items: CartItem[]
  isLoading: boolean
  error: string | null
  drawerOpen: boolean

  // Derived
  itemCount: number
  totalBySellerCount: number

  // Actions
  setItems: (items: CartItem[]) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  openDrawer: () => void
  closeDrawer: () => void
  toggleDrawer: () => void
}

export const useCartStore = create<CartState>((set, get) => ({
  items: [],
  isLoading: true,
  error: null,
  drawerOpen: false,
  itemCount: 0,
  totalBySellerCount: 0,

  setItems: (items) => {
    const itemCount = items.reduce((sum, item) => sum + item.quantity, 0)
    const sellers = new Set(items.map((item) => item.sellerId))
    set({ items, itemCount, totalBySellerCount: sellers.size, isLoading: false, error: null })
  },

  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error, isLoading: false }),

  openDrawer: () => set({ drawerOpen: true }),
  closeDrawer: () => set({ drawerOpen: false }),
  toggleDrawer: () => set({ drawerOpen: !get().drawerOpen }),
}))
